import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.scss';

const footerLinks = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about' },
  { label: 'Recruitment', to: '/rush' },
  { label: 'Members', to: '/members' },
  { label: 'Alumni', to: '/alumni' },
  { label: 'Gallery', to: '/gallery' },
  { label: 'Contact', to: '/contact' },
];

function Footer() {
  return (
    <footer className="FooterContainer">
      <div className="FooterContents">
        <div className="FooterIdentity">
          <section className="FooterContact" aria-labelledby="footer-contact-title">
            <h2 id="footer-contact-title">Contact Us</h2>
            <a className="FooterLink" href="mailto:thetatauslo@gmail.com">thetatauslo@gmail.com</a>
            <a className="FooterLink" href="mailto:president.thetatauslo@gmail.com">president.thetatauslo@gmail.com</a>
          </section>
        </div>

        <div className="FooterGroups">
          <nav className="FooterNav" aria-label="Footer navigation">
            <h2>Explore</h2>
            <div className="FooterNavLinks">
              {footerLinks.map((link) => (
                <Link className="FooterLink FooterNavItem" key={link.to} to={link.to}>
                  {link.label}
                </Link>
              ))}
            </div>
          </nav>

          <section className="FooterSocial" aria-labelledby="footer-social-title">
            <h2 id="footer-social-title">Follow Us</h2>
            <a className="FooterLink" href="https://www.instagram.com/thetatauslo/" target="_blank" rel="noreferrer">Instagram</a>
          </section>

          <section className="FooterNational" aria-labelledby="footer-national-title">
            <h2 id="footer-national-title">National Theta Tau</h2>
            <a className="FooterLink" href="https://thetatau.org" target="_blank" rel="noreferrer">thetatau.org</a>
          </section>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
